import React from "react";
import EditableTable from "../../../../../../../../components/Tables/EditableTable";
import { useBidContext } from "../Bid.context";

const ECSBidEvalutionView = () => {
  const { selectedBidVendors } = useBidContext();

  const vendors = React.useMemo(() => {
    if (Array.isArray(selectedBidVendors) && selectedBidVendors.length) {
      if (typeof selectedBidVendors[0] === "string") {
        return selectedBidVendors.map((name, idx) => ({
          id: idx + 1,
          name,
        }));
      }
    }
  }, [selectedBidVendors]);

  const typeOptions = ["Technical", "Commercial", "Delivery"];

  const ecsColumns = React.useMemo(() => {
    const fixedCols = [
      {
        header: "#",
        id: "rowIndex",
        size: 60,
        Cell: ({ row }) => row.index + 1,
        enableEditing: false,
        enableCreating: false,
      },
      {
        accessorKey: "type",
        header: "Description",
        editVariant: "select",
        editSelectOptions: typeOptions,
        muiEditTextFieldProps: { select: true },
      },
      {
        accessorKey: "asPerSpecs",
        header: "As per specs",
        muiEditTextFieldProps: {
          placeholder: "Write specs",
        },

        Cell: ({ cell }) => cell.getValue() ?? "",
      },
    ];

    const vendorCols = vendors.map((v) => ({
      id: `vendor_${v.id}`,
      header: v.name,
      accessorFn: (row) =>
        row.vendorValues?.[v.id] ?? "Vendor temp description data",
      enableEditing: false,
      Cell: ({ row }) =>
        row.original.vendorValues?.[v.id] ?? "Vendor temp description data",
    }));

    return [...fixedCols, ...vendorCols];
  }, [vendors, typeOptions]);

  const [dummyRows, setDummyRows] = React.useState(() => []);

  React.useEffect(() => {
    setDummyRows((prev) =>
      prev.map((r) => ({
        ...r,
        vendorValues: {
          ...Object.fromEntries(
            vendors.map((v) => [v.id, "Vendor temp description data"]),
          ),
          ...(r.vendorValues || {}),
        },
      })),
    );
  }, [vendors]);

  const dummyApi = React.useMemo(
    () => ({
      getItems: async (parentId) => {
        return dummyRows;
      },
      createItem: async (parentId, item) => {
        const newRow = {
          ...item,
          id: Math.floor(Math.random() * 1000000),
          vendorValues:
            item.vendorValues ??
            Object.fromEntries(
              vendors.map((v) => [v.id, "Vendor temp description data"]),
            ),
        };
        setDummyRows((prev) => [...prev, newRow]);
      },
      updateItem: async (item) => {
        setDummyRows((prev) =>
          prev.map((r) => (r.id === item.id ? { ...r, ...item } : r)),
        );
      },
      deleteItem: async (id) => {
        setDummyRows((prev) => prev.filter((r) => r.id !== id));
      },
    }),
    [dummyRows, vendors],
  );

  return (
    <EditableTable
      name="ECS Bid Evaluation"
      parentId={123} // dummy parent id
      api={dummyApi}
      displayMode="modal"
      enableEditing={true}
      enableCreate={true}
      columns={ecsColumns}
      enableDelete={true}
    />
  );
};

export default ECSBidEvalutionView;
